import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const HOURTYPEGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.HourTypeGroup.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .text('code', 'Entity.HourTypeGroup.Code')
    .required()
    .minLength(1)
    .maxLength(4)
    .build(),
];

export const HOURTYPEGROUP_CONFIG = {
  entityName: 'HourTypeGroup',
  localizationKey: 'General::Entity.HourTypeGroup',
  fields: HOURTYPEGROUP_FIELDS,
  permission: 'ControllingCalendar.HourTypeGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
